import { ModuleWithProviders, NgModule } from '@angular/core';

import { I18nModule } from '@recruitee/i18n';

import { RtRedactorInsertsSharedModule } from './readctor-inserts/readctor-inserts.module';
import {
  NoopWysiwygUploader,
  WysiwygUploader,
  WysiwygUploaderProvider,
} from './redactor/extensions/upload/upload.types';
import { RedactorModule } from './redactor/redactor.module';
import {
  NoopWysiwygData,
  WysiwygData,
  WysiwygDataProvider,
} from './wysiwyg-extensions/adapter/wysiwyg-adapter.types';
import { WysiwygLinkModule } from './wysiwyg-extensions/link/wysiwyg-link.module';
import { WysiwygPlaceholderModule } from './wysiwyg-extensions/placeholders/wysiwyg-placeholder.module';

@NgModule({
  imports: [I18nModule, WysiwygPlaceholderModule, RedactorModule, RtRedactorInsertsSharedModule],
  exports: [WysiwygPlaceholderModule, WysiwygLinkModule, RedactorModule],
})
export class RtWysiwygModule {
  public static forRoot(
    uploaderProvider?: WysiwygUploaderProvider,
    dataProvider?: WysiwygDataProvider,
  ): ModuleWithProviders<RtWysiwygModule> {
    return {
      ngModule: RtWysiwygModule,
      providers: [
        uploaderProvider
          ? uploaderProvider
          : {
              provide: WysiwygUploader,
              useClass: NoopWysiwygUploader,
            },
        dataProvider
          ? dataProvider
          : {
              provide: WysiwygData,
              useClass: NoopWysiwygData,
            },
      ],
    };
  }
}

export * from './wysiwyg-extensions/link/wysiwyg-link.types';
export * from './wysiwyg-extensions/adapter/wysiwyg-adapter.types';
